import LiveForm from '../nette/LiveForm'
import NetteAjax from '../nette/NetteAjax'
import Store from '../store'
import $ from 'cash-dom'
import { watchEffect, nextTick } from 'vue'
import $formValues from '../nette/FormValues'
import $formErrors from '../nette/FormErrors'

export default {
  install (Vue, context) {
    if (context.liveForm) {
      LiveForm.setOptions(context.liveForm)
    }

    

    Vue.mixin({
      beforeCreate() {
        // provide $formValues[ ELEMENT ID ] for v-model which is updated in store
        this.$formValues = $formValues
        this.$formErrors = $formErrors
      }
    })

    Vue.directive('nette-form', {
      mounted (el, binding) {
        nextTick(() => {
          const form = el
          if (binding.value?.onValidate) {
            form.clbOnValidate = binding.value.onValidate
          }

          const formId = form.getAttribute('id')

          // we need to wait for subcomponents are rendered before init form
          // toggles does not work correctly when added to the form after init
          setTimeout(() => {
            LiveForm.Nette.initForm(form)

            // LiveForm: addition
            if (LiveForm.hasClass(form, 'validate-on-load')) {
              // This is not so nice way, but I don't want to spoil validateForm, validateControl and other methods with another parameter
              LiveForm.setFormProperty(form, 'onLoadValidation', true)
              LiveForm.Nette.validateForm(form)
              LiveForm.setFormProperty(form, 'onLoadValidation', false)
            }

            if (Store.state.nette.$controls[formId]) {
              form.stopWatchErrors = watchEffect(() => {
                const errorsByElement = {}
                if (Store.state.nette.$controls[formId]) {
                  Store.state.nette.$controls[formId].components.forEach((elId) => {
                    if (Store.state.nette.$controls[elId]?.hasErrors) {
                      errorsByElement[elId] = Store.state.nette.$controls[elId].errors
                    }
                  })

                  if (Store.state.nette.$controls[formId]['action']) {
                    form.action = Store.state.nette.$controls[formId]['action']
                  }
                }
              
                setTimeout(() => {
                  for (let k in errorsByElement) {
                    let frmEl = document.getElementById(k)
                    if (frmEl) {
                      LiveForm.addError(frmEl, errorsByElement[k].join(''))
                    }
                  }

                  if (form.clbOnValidate) {
                    form.clbOnValidate()
                  }
                }, 300)
              })
            }

            let submitBtn = null
            let submitEvt = null
            
            const $form = $(form);
            $form.off('click.netteForm')
            $form.off('submit.netteForm')
            $form.off('keydown.netteForm')
            $form.off('keyup.netteForm')
            $form.off('change.netteForm')

            $form.on('click.netteForm', '[type="submit"]', function (e) {
              const target = this
              if (target.form && target.type in { submit: 1, image: 1 }) {
                submitBtn = target.form['nette-submittedBy'] = target
                submitEvt = e
              }
              // validate form
              LiveForm.Nette.validateForm(form)
              if (e?.namespace === 'netteForm') {
                e.stopPropagation()
              }
            })

            $form.on('submit.netteForm', function (e) {
              if (!LiveForm.forms[formId] || LiveForm.forms[formId].hasError === false) {
                if (form.hasAttribute('data-ajax-use-router')) {
                  NetteAjax.ext('vue-router').callAjax(form.action, submitBtn || form, submitEvt || e, true)
                } else {
                  NetteAjax.ajax({}, submitBtn || form, submitEvt || e)
                }

                submitBtn = submitEvt = null
              }
              e.preventDefault()
              e.stopPropagation()
              return false
            })

            // enterem se skutecne bude jen odesilat cely formular via hlavni tlaticko nekde na konci s tridou .form-submit-btn
            // <RJ, 15.04.2021 11:00:30>
            $form.on('keydown.netteForm', 'input[name]:not([type="submit"])', function(e) {
              const keyCode = e.which || e.keyCode
              if (keyCode === 13) {
                const formSubmitBtn = $form.find('.form-submit-btn');
                if (formSubmitBtn.length) {
                  formSubmitBtn.trigger('click')
                  return false
                }
              }
            })

            const canChangeSelector = '.formOnChangeSubmit:not(input[type="radio"]), input[type="radio"].formOnChangeSubmit:checked';
            $(canChangeSelector, form).not('input[type="checkbox"]').each(function() {
                const $this = $(this);
                if ($this.data('oldValue') == $this.val()) return

                if ($this.attr('type') == 'radio') {
                    $('input[type="radio"][name="'+ $this.attr('name') +'"]').data('oldValue', $this.val())
                } else {
                    $this.data('oldValue', $this.val())
                }

                console.log('formOnChangeSubmit each', $this)
            })

            let submitTimeout = null
            $form.on('change.netteForm keyup.netteForm', canChangeSelector, function (e) {
              e.preventDefault();
              const $this = $(this);
              
              if (!$this.is('input[type="checkbox"]')) {
                if ($this.data('oldValue') == $this.val()) return

                if ($this.attr('type') == 'radio') {
                    $('input[type="radio"][name="'+ $this.attr('name') +'"]').data('oldValue', $this.val())
                } else {
                    $this.data('oldValue', $this.val())
                }
              }

              let $btn = null;
              if ($this.data('submitBtn')) {
                $btn = $form.find('[type="submit"][name="'+$this.data('submitBtn')+'"], [type="button"][name="'+$this.data('submitBtn')+'"]')
              } else {
                $btn = $form.find('[type="submit"]')
              }

              form['nette-submittedBy'] = $btn.get(0)
              
              if (submitTimeout)
                clearTimeout(submitTimeout)
              
              submitTimeout = setTimeout(function () {
                if (LiveForm.Nette.validateForm(form, true)) {
                  $btn.trigger('click.netteForm')
                }
              }, $this.is('input[type="radio"]') || $this.is('input[type="checkbox"]') ? 0 : ($this.is('select') ? $this[0].getAttribute('data-onchange-submit-time') ?? 250 : $this[0].getAttribute('data-onchange-submit-time') ?? 750))
            })
          }, 300)
        })
      },

      beforeUnmount (el) {
        if (el.stopWatchErrors) {
          el.stopWatchErrors()
        }

        if (el.clbOnValidate) {
          el.clbOnValidate = null
        }
      }
    })
  }
}
